import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import apiClient from '../api/client';
import Logo from '../components/Logo';
import './Login.css';

// Importar logo (se existir)
let logoImage;
try {
  logoImage = require('../assets/images/logo.png');
} catch (e) {
  logoImage = null;
}

/**
 * Página de Esqueci Minha Senha
 */

const EsqueciSenha = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      await apiClient.post('/auth/esqueci-senha', { email });
      
      setSuccess(true);
    } catch (err) {
      console.error('Erro ao solicitar reset:', err);
      // Mesmo em caso de erro, mostrar mensagem de sucesso (por segurança)
      setSuccess(true);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="login-container">
        <div className="login-box">
          <div className="login-logo">
            <Logo size="large" imageSrc={logoImage || undefined} />
          </div>
          <h2>✅ Email Enviado!</h2>
          
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <p>
              Se o email <strong>{email}</strong> estiver cadastrado, você receberá um link para redefinir sua senha.
            </p>
            <p style={{ marginTop: '15px', fontSize: '14px', color: '#666' }}>
              Verifique sua caixa de entrada e spam.
            </p>
            <p style={{ marginTop: '15px', fontSize: '14px', color: '#666' }}>
              O link expira quando você definir uma nova senha.
            </p>
          </div>

          <div className="login-footer" style={{ marginTop: '30px' }}>
            <Link to="/login" className="btn btn-primary btn-block">
              Voltar para Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-logo">
          <Logo size="large" imageSrc={logoImage || undefined} />
        </div>
        <h2>Esqueci Minha Senha</h2>
        
        <p style={{ textAlign: 'center', marginBottom: '20px', color: '#666' }}>
          Digite seu email e enviaremos um link para redefinir sua senha.
        </p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              placeholder="seu@email.com"
            />
          </div>

          {error && <div className="error">{error}</div>}

          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar Link de Redefinição'}
          </button>
        </form>

        <div className="login-footer">
          <p className="footer-signature">Produzido by <strong>Chicão</strong></p>
          <p>
            <Link to="/login">Voltar para Login</Link>
          </p>
          <p>
            Não tem uma conta? <Link to="/cadastro">Cadastre-se aqui</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default EsqueciSenha;
